export default {
  title: {
    loading: "Loading...",
    noOptions: "Geen keuze mogelijkheid",
    select: "Selecteer een optie",
  },

  autoTitle: {
    fallback: "Selecteer een optie",
    noOptions: "Geen keuze mogelijkheid"
  }
}
